import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../Services/api";
import Header from "../../component/Header";
import { useSwal } from "../../component/sweetalert";
import HashtagSelect from "../../component/HashtagSelect";
import "react-quill-new/dist/quill.snow.css";
import "../AddBlog/index.css";

export default function EditBlog() {
  const { id } = useParams();
  const alert = useSwal();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    heading: "",
    content: "",
    hashtags: "",
  });
const [loading, setLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);
  const [eventImage, setEventImage] = useState("");

  const sanitizeContent = (html) => {
    if (!html) return "";
    return html
      .replace(/src=""+(http[^"]+)"/g, 'src="$1"')
      .replace(/src="\/uploads\/blog/g, `src="${process.env.REACT_APP_API_PRJ_URL}/uploads/blog`);
  };

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await api.post(`/upadteeditblog/${id}`);
        const data = response.data;
        const sanitizedContent = sanitizeContent(data.content);
        setFormData({
          heading: data.heading,
          content: sanitizedContent,
          hashtags: data.hashtags || "",
        });

        if (data.image && data.image.length > 0) {
          setEventImage(data.image[0]); // Only first image is considered here
        }
      } catch (error) {
        alert("error", "Error fetching blog details");
      }
    };
    fetchBlog();
  }, [id, alert]);

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, content: value }));
  };
const handleFileChange = (e) => {
  const file = e.target.files[0];
  const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
  if (file && !validTypes.includes(file.type)) {
    alert("error", "Only JPG, JPEG, PNG, WEBP files are allowed.");
    return;
  }
  setSelectedFile(file);
  console.log(file); // Add this to see if the file is properly set
};


const handleSubmit = async (event) => {
  event.preventDefault();
  setLoading(true);
  try {
    const form = new FormData();
    form.append("heading", formData.heading);
    form.append("content", sanitizeContent(formData.content));
    form.append("hashtags", formData.hashtags);
    form.append("image", selectedFile); // Appending the selected file

    await api.post(`/editblog/${id}`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    await alert("success", "Blog updated successfully!");
    navigate("/blog-view");
  } catch (error) {
    console.error("Error updating blog:", error);
    await alert("error", "Error updating blog");
  }finally {
      setLoading(false);
    }
};

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Edit Blog Details" backTo="/blog-view" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-start col-xl-6 col-12">
          <form className="form-fields d-flex" onSubmit={handleSubmit}>
            <div className="grid-container user">
              <div className="input-container">
                <input
                  type="text"
                  name="heading"
                  value={formData.heading}
                  onChange={handleChange}
                  placeholder="Enter Blog Title"
                  required
                />
                <span className="underline"></span>
              </div>

              <div className="input-container description-container">
                <ReactQuill
                  value={formData.content}
                  onChange={handleQuillChange}
                  theme="snow"
                  placeholder="Write your blog content here..."
                  className="react-quill-wrapper"
                  modules={quillModules}
                />
              </div>

              <HashtagSelect
                value={formData.hashtags}
                onChange={(hashtags) => setFormData((prev) => ({ ...prev, hashtags }))}
              />

              <div className="input-container file-input-container">
                <input type="file" onChange={handleFileChange} accept=".jpg, .jpeg, .png, .webp" />
                {selectedFile ? (
                  <p className="file-name">{selectedFile.name}</p>
                ) : eventImage ? (
                  <p className="file-name">{eventImage.split("/").pop()}</p>
                ) : (
                  <p>No Image Uploaded</p>
                )}
              </div>

              <div className="grid-item">
                <button className="btn btn-purpal update" type="submit" disabled={loading}>
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
